import React from 'react';
import { useTranslation } from 'react-i18next';
import american from '@panel/commons/assets/img/american_express_logo.svg';
import maestro from '@panel/commons/assets/img/maestro_logo.svg';
import mastercard from '@panel/commons/assets/img/mastercard_logo.svg';
import visa from '@panel/commons/assets/img/visa_logo.svg';
import { PaymentMethodsContainer } from '../styles';

const PaymentMethods = () => {
  const { t } = useTranslation();

  return (
    <PaymentMethodsContainer>
      <p>{t('publisher.step4.module1.paymentMethods')}</p>
      <div>
        <img src={visa} alt='logoVisa' />
        <img src={american} alt='logoAmericanExpress' />
        <img src={mastercard} alt='logoMastercard' />
        <img src={maestro} alt='logoMaestro' />
      </div>
    </PaymentMethodsContainer>
  );
};

export { PaymentMethods };
